import { NgModule } from '@angular/core';

import { epicObs } from '../../../store';

import { CmpsWinningCommitmentsDialogModule } from './commitment-details-dialog/commitment-details-dialog.module';
import { WinningPercentageService } from './core';
import { mainEpics } from './main/main.epic';
import { CmpsCoachingWpMainModule } from './main/main.module';

@NgModule({
    exports: [CmpsCoachingWpMainModule],
    imports: [CmpsCoachingWpMainModule, CmpsWinningCommitmentsDialogModule],
    providers: [WinningPercentageService],
})
export class CmpsCoachingWinningPercentageModule {
    constructor() {
        mainEpics.forEach((e) => epicObs.next(e));
    }
}
